import React from "react";
import Section from "Section";
import Title from "components/Title";
import SUPEREGGY from "./media/supereggy.png";
import WILDWEST from "./media/wildwest.png";
import GRAVITY from "./media/gravity.png";

export default function Header() {
  return (
    <Section bcolor="#27313B">
      <div className="about-anchor" id="about" />
      <div className="about-title">
        <Title text="About RU Hacks" />
      </div>
      <div className="about-con">
        <div className="about-con-poster">
          <div className="about-con-poster-text">Coming Soon</div>
          <div
            className="about-con-poster-image"
            style={{ backgroundImage: `url(${SUPEREGGY})` }}
          >
            {" "}
          </div>
        </div>
        <div className="about-con-background-poster ">
          <div className="about-con-poster blur separator bg">
            <div className="about-con-poster-text">Coming Soon</div>
            <div
              className="about-con-poster-image "
              style={{ backgroundImage: `url(${WILDWEST})` }}
            >
              {" "}
            </div>
          </div>
          <div className="about-con-poster blur separator bg">
            <div className="about-con-poster-text">Coming Soon</div>
            <div
              className="about-con-poster-image "
              style={{ backgroundImage: `url(${GRAVITY})` }}
            >
              {" "}
            </div>
          </div>
        </div>
      </div>
      <div className="about-info">
        <div>
          <div className="about-info-q">
            <h3>What is RU Hacks?</h3>
            <span>
              RU Hacks is Ryerson University’s student-run hackathon, an event
              open to anyone around the globe! Going into our sixth year, we
              invite you to join us in an array of stellar workshops, events and
              mentorship opportunities, all hosted by a variety of incredible
              and diverse individuals! As an opportunity to meet new people and
              showcase your hard work, we hope to see you there!
            </span>
          </div>
        </div>
        <div>
          <div className="about-info-q">
            <h3>Why attend?</h3>
            <span>
              Are you interested in creating unique projects while meeting other
              talented and passionate students? Well it’s just your luck,
              because RU Hacks is here to present you with this opportunity! RU
              Hacks provides students with the chance to interact with industry
              professionals, develop new skills and collaborate with fellow
              innovators to bring their ideas to reality!
            </span>
          </div>
        </div>
      </div>
    </Section>
  );
}
